module.exports = __webpack_public_path__ + "img/section5_1.24d72d44.png";